import React, { PureComponent } from 'react';

import { Loader } from 'react-loaders';

import { batchRequest } from '../../../../../../api/ApiService';

import {
  Wrapper,
  PreTitle,
  Title,
  Text,
  ContentContainer,
  ContentFlexColumns,
  Image
} from '../../../components/ui';

import DataDetails from '../../../components/data-details';

import ImageSource from '../../../../../../containers/assets/dominate-personalities.png';

class DominantPersonalities extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      mostDominantUsers: [],
      loaded: false
    };
  }

  componentDidMount() {
    const { currentFinishedSurvey } = this.props;
    batchRequest([
      `${process.env.REACT_APP_API_URL}users`,
      `${process.env.REACT_APP_API_URL}v2/forms/answers-list/?survey=${currentFinishedSurvey.id}`,
    ])
      .then(res => {
        const users = res[0].body;
        const formsAnswersList = res[1].body.results;
        const mostDominant = formsAnswersList.filter(formsAnswer =>
          formsAnswer.question_category === 'Collaboration'
          && formsAnswer.question_text.toLowerCase().includes('dominates discussions')
          && Number(formsAnswer.answer_text) >= 1
          && Number(formsAnswer.answer_text) < 3
        ).sort((a, b) => Number(a.answer_text) - Number(b.answer_text));

        const mostDominantUsers = [...new Set(mostDominant.map(item => {
          const user = users.find(user => user.email === item.receiver_email);
          return `${user.first_name} ${user.last_name}`
        }))];

        this.setState({
          loaded: true,
          mostDominantUsers
        });
      })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      mostDominantUsers
    } = this.state;

    return loaded ? (
      <Wrapper>
        <PreTitle>Individual</PreTitle>
        <Title>Dominant Personalities</Title>
        <Text>
          <p>There were also <b>{mostDominantUsers.length}</b> students that might have been dominating their team’s discussions, making it difficult for others to share their points..</p>
        </Text>
        <ContentContainer transparent={true}>
          <ContentFlexColumns withFloatinDetailsBlock={true}>
            <Image src={ImageSource} alt="Now that you are all my little drones, I encourage you to speak my mind." />
          </ContentFlexColumns>
          <DataDetails
            title="Most Dominant"
            color="#FE7474"
            data={mostDominantUsers}
            centered={true}
          />
        </ContentContainer>
      </Wrapper>
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default DominantPersonalities;



// WEBPACK FOOTER //
// ./src/instructor/components/peer-feedback/pages/dynamics/individual/dominant-personalities.js